import React from "react";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const { user, loading } = useAuth();

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) return <div className="py-20 text-center text-slate-500">Loading…</div>;

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 p-8 text-center">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 grid place-items-center">
          <LogIn size={22} />
        </div>
        <h1 className="mt-5 text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">Admin sign in</h1>
        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">Sign in with Google to manage content.</p>

        {user && !user.is_admin && (
          <p className="mt-4 text-xs text-red-600 dark:text-red-400">Signed in as {user.email} — but this account is not an admin.</p>
        )}

        <button
          onClick={login}
          data-testid={ADMIN.loginButton}
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <LogIn size={16} /> Continue with Google
        </button>
      </div>
    </div>
  );
}
